import { render, staticRenderFns } from "./impresionData.vue?vue&type=template&id=3f988a00"
import script from "./impresionData.vue?vue&type=script&lang=js"
export * from "./impresionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports